import { render, staticRenderFns } from "./CMFiltersChips.vue?vue&type=template&id=3f1c57e2&lang=pug"
import script from "./CMFiltersChips.vue?vue&type=script&lang=js"
export * from "./CMFiltersChips.vue?vue&type=script&lang=js"
import style0 from "./CMFiltersChips.vue?vue&type=style&index=0&id=3f1c57e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports